import { IonContent, IonPage } from '@ionic/react';

import {
  Logo,
  Maintenance as MaintenanceComponent,
  Padding
} from '@/components/common';

import './Maintenance.css';

const Maintenance: React.FC = () => {
  return (
    <IonPage id="default">
      <IonContent>
        <Padding>
          <Logo />
          <MaintenanceComponent />
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default Maintenance;
